<template>
  <v-breadcrumbs
    :items="breadcrumbs"
    large
    itemscope="itemscope"
    itemtype="http://schema.org/BreadcrumbList"
    class="pb-0 pt-2"
  >
    <template v-slot:item="{item}">
      <v-breadcrumbs-item
        itemprop="itemListElement"
        itemscope="itemscope"
        itemtype="http://schema.org/ListItem"
        :href="item.href"
        :disabled="item.disabled"
      >
        <meta itemprop="position" :content="item.position">
        <a itemprop="item" :href="item.href" class="breadcrumbs_item">
          <span itemprop="name">{{ item.text }}</span>
        </a>
      </v-breadcrumbs-item>
    </template>
  </v-breadcrumbs>
</template>


<script>

import { mapState } from 'vuex';

export default {
  name: "Breadcrumbs",
	computed: { 
		...mapState({
      city_name: (state) => state.LandingM.city_name,
      page_name: (state) => state.LandingM.page_name, 
      selected_cities: (state) => state.citiesM.selected_cities,
		}),
		breadcrumbs() { 
      let breads = [
        {
          text: 'Poiskokna',
          disabled: false,
          href: '/',
          position: '1',
        },
      ];
      if (this.selected_cities.length === 1) { 
        breads.push({
          text: this.selected_cities[0].name,
          disabled: false,
          href: `/${this.selected_cities[0].slug}`,
          position: 2,
        })
      }
      if (this.page_name) { 
        breads.push({
          text: this.page_name,
          disabled: true,
          href: '/',
          position: 3,
        })
      }
      return breads 
		},
	},
};
</script>
